/* src/app/forms/acess-view/copy-acess-popup/copy-acess-popup.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 10px;
  font-family: var(--tem-font-family);
}
.separatorCenter {
  margin-top: 10px;
  text-align: center;
  color: var(--tem-ink);
}
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  width: 100%;
  gap: 4px;
}
.lblUsuDest {
  margin: 6px 0 0 2px;
  font-weight: bold;
  color: var(--tem-ink);
}
.dest-count {
  font-weight: normal;
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
}
.dest-spin {
  flex: 1;
  display: block;
  overflow: hidden;
}
:host ::ng-deep .dest-spin > .ant-spin-container {
  height: 100%;
}
.dest-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
  overflow: auto;
  padding: 10px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface-2);
}
.dest-list label {
  margin: 0;
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.clear-icon:hover {
  color: var(--tem-ink);
}
.finish {
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
}
/*# sourceMappingURL=copy-acess-popup.component.css.map */
